import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ScheduleDetailsDialogComponent } from './schedule-details-dialog.component';
import { ScheduleModel } from './schedule.model';
import { PreinvoiceModel } from '../invoice/preinvoice/preinvoice.model';
import { InvoiceLineModel } from '../invoice/preinvoice/invoiceline.model';
import { CoreComponent } from '../../core/header/core.component';
import { AccountsAndTaxesModel } from '../invoice/preinvoice/accountsandtaxes.model';
import { BankAccountModel } from '../finanzas/bancos/bankaccount.model';
import { UserCompanyService } from '../user/usercompany/usercompany.service';
import { ActualSelected, Utils } from '../../shared/utils';
import { UserContactService } from '../user/usercontact/usercontact.service';
import { PreinvoiceService } from '../invoice/preinvoice/preinvoice.service';
import { ContactModel } from '../contact/contact/contact.model';
import { ContactService } from '../contact/contact/contact.service';
import { ActivityService } from '../user/activity/activity.service';
import { ActivityModel } from '../user/activity/activity.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConceptModel } from '../concept/concept/concept.model';
import { ConceptService } from '../concept/concept/concept.service';
import { TaxCalculator } from '../../shared/taxCalculator';

@Component({
    selector: 'preinvoice-schedule-wrapper',
    templateUrl: './preinvoice-schedule-wrapper.component.html',
    standalone: false
})

export class PreinvoiceScheduleWrapperComponent implements OnInit {

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<ScheduleDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private core: CoreComponent,
        private userCompanyService: UserCompanyService,
        private userContactService: UserContactService,
        private preinvoiceService: PreinvoiceService,
        private contactService: ContactService,
        private activityService: ActivityService,
        private conceptService: ConceptService,
        public snackBar: MatSnackBar,
        private router: Router,
        private taxCalculator: TaxCalculator
    ) { }

    preinvoice: PreinvoiceModel = new PreinvoiceModel();
    accountsAndTaxes: AccountsAndTaxesModel;
    contactList: ContactModel[] = this.data.contacts;
    bankAccounts: BankAccountModel[];
    working = true;
    ready = true;

    public displayError(error: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10500;
        this.snackBar.open(error, '', options);
    }

    ngOnInit(): void {
        let receiver: ContactModel = new ContactModel();
        let concept: ConceptModel = new ConceptModel();
        this.contactService.loadData(this.data.newEvent.contactUid).then(response => {
            receiver = response;
            this.preinvoice.receiverUid = receiver.uid;
            this.preinvoice.receiverName = receiver.companyName;

            this.preinvoice.invoiceLines = new Array<InvoiceLineModel>();
            this.preinvoice.invoiceLines.push(new InvoiceLineModel());
            this.preinvoice.activityUid = ActualSelected.activitySelected;

            this.preinvoice.invoiceRelease = new Date();
            const expiration = new Date(this.preinvoice.invoiceRelease);
            expiration.setMonth(expiration.getMonth() + 1);
            this.preinvoice.invoiceExpiration = expiration;

            this.preinvoice.invoiceLines = new Array<InvoiceLineModel>();
            this.userCompanyService.loadData().then(userCompany => {
                this.preinvoice.issuerName = userCompany.companyName;
                this.preinvoice.issuerVatNumber = userCompany.vatNumber;
                this.userContactService.loadData().then(userContact => {

                    if (Utils.IsNullOrEmpty(this.preinvoice.issuerAddress)) {
                        this.preinvoice.issuerAddress = userContact.address;
                    }

                    if (Utils.IsNullOrEmpty(this.preinvoice.issuerPostalCode)) {
                        this.preinvoice.issuerPostalCode = userContact.postalCode;
                    }

                    if (Utils.IsNullOrEmpty(this.preinvoice.issuerLocation)) {
                        this.preinvoice.issuerLocation = userContact.location;
                    }

                    if (Utils.IsNullOrEmpty(this.preinvoice.issuerCountry)) {
                        this.preinvoice.issuerCountry = userContact.country;
                    }

                    if (Utils.IsNullOrEmpty(this.preinvoice.issuerState)) {
                        this.preinvoice.issuerState = userContact.state;
                    }

                })
                this.preinvoiceService.accountsAndTaxesData().then(accountsAndTaxes => {
                    this.accountsAndTaxes = accountsAndTaxes;
                    this.activityService.loadData(ActualSelected.activitySelected).then(response => {
                        let loadActivity = new ActivityModel;
                        loadActivity = response;
                        this.preinvoice.preInvoiceNumber = loadActivity.preinvoiceNumber;

                        if (this.data.newEvent.conceptUid != '00000000-0000-0000-0000-000000000000') {
                            this.conceptService.loadData(this.data.newEvent.conceptUid).then(response => {
                                concept = response;
                                const line = new InvoiceLineModel();
                                line.product = concept.name;
                                line.conceptUid = concept.uid;
                                line.netPrice = concept.netPrice;
                                line.taxes = concept.taxes;
                                line.quantity = 1;
                                line.unityAmount = concept.price;
                                line.totalLine = this.calcularTotalesLinea(line);
                                this.preinvoice.invoiceLines.push(line);
                                this.working = false;
                            })
                        } else {
                            const line = new InvoiceLineModel();
                            const raw = this.data.newEvent.observations || '';
                            const index = raw.indexOf('Concepto libre:');
                            let conceptoLibre = '';
                            if (index !== -1) {
                                conceptoLibre = raw.substring(index + 'Concepto libre:'.length).trim();
                            }
                            line.product = conceptoLibre;
                            this.preinvoice.invoiceLines.push(line);
                            this.working = false;
                        }
                    })
                });

            });
        });

    }

    public returnToIndex(): void {
        this.router.navigate(['invoice/preinvoice']);
    }

    public saveData(preinvoice: PreinvoiceModel): void {
        this.ready = false;
        preinvoice.fiscalYear = Number(ActualSelected.yearSelected);
        preinvoice.activityUid = ActualSelected.activitySelected

        this.preinvoiceService.addData(preinvoice)
            .then(preinvoice => {
                this.preinvoice = preinvoice;
                this.preinvoice.activityUid = this.core.activitySelected;
                this.preinvoiceService.saveRequestUpdateValue(false);
                this.ready = true;
                this.dialogRef.close();
                this.returnToIndex();
            })
            .catch(errors => {
                this.preinvoiceService.saveRequestUpdateValue(false);
                if (errors && errors.error && errors.error.message) {
                    this.displayError(errors.error.message);
                } else {
                    this.displayError('Compruebe los campos obligatorios marcados en rojo');
                }
            })

    }

    calcularTotalesLinea(invoiceLine) {
        invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
        return invoiceLine.totalLine;
    }
}
